export const finalExamCriteriaEnum = {
    generalSkills: 0,
    mainSkills: 1,
};